import { render, staticRenderFns } from "./TitleView.vue?vue&type=template&id=5a31e01a&scoped=true&"
import script from "./TitleView.vue?vue&type=script&lang=js&"
export * from "./TitleView.vue?vue&type=script&lang=js&"
import style0 from "./TitleView.vue?vue&type=style&index=0&id=5a31e01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31e01a",
  null
  
)

export default component.exports